// extracted by mini-css-extract-plugin
export default {"searchInput":"src-constrains-Query1-SearchInput-css-module__searchInput--v3mxu"};